var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 3,
    fill: "#201CE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.185 6.63h-.611v-.284c0-.743-.604-1.346-1.346-1.346H7.772c-.743 0-1.346.604-1.346 1.346v.284h-.611A.816.816 0 0 0 5 7.444v1.223c0 .898.731 1.63 1.63 1.63h.126a4.41 4.41 0 0 0 1.764 2.079c.242.15.497.27.758.36v1.024H8.259a.407.407 0 0 0-.374.247l-.611 1.426a.408.408 0 0 0 .374.568h5.704a.407.407 0 0 0 .374-.568l-.61-1.426a.407.407 0 0 0-.375-.247h-1.019v-1.024c.261-.09.516-.21.758-.36a4.41 4.41 0 0 0 1.764-2.08h.126c.899 0 1.63-.731 1.63-1.63V7.445a.816.816 0 0 0-.815-.814zm-8.76 2.826a.816.816 0 0 1-.61-.79V7.445h.61v2.012zm6.309 5.73H8.265l.262-.612h3.944l.262.611zm-1.827-1.427h-.815v-.84c.135.015.271.025.407.025.136 0 .272-.01.408-.025v.84zm1.143-2.076a2.923 2.923 0 0 1-3.1 0 3.592 3.592 0 0 1-1.71-3.071V6.346c0-.292.239-.53.531-.53h5.456c.293 0 .531.238.531.53v2.266c0 1.26-.638 2.408-1.709 3.071zm3.135-3.016c0 .378-.26.698-.611.789V7.444h.61v1.223z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.346 7.995-1.024-.15-.457-.926a.408.408 0 0 0-.731 0l-.458.927-1.023.149a.407.407 0 0 0-.226.694l.74.722-.174 1.02a.408.408 0 0 0 .59.43l.916-.482.916.481a.404.404 0 0 0 .428-.03.407.407 0 0 0 .162-.4l-.174-1.019.74-.722a.407.407 0 0 0-.226-.694h.001zm-1.237.982a.41.41 0 0 0-.117.361l.072.417-.375-.197a.408.408 0 0 0-.379 0l-.374.197.072-.417a.41.41 0 0 0-.117-.36l-.303-.296.419-.061a.407.407 0 0 0 .307-.223l.187-.379.186.379c.06.12.175.204.307.223l.42.061-.304.295h-.001z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsIcon);
export default __webpack_public_path__ + "static/media/results-icon.b74989e3a115ef511cff1084dd8b1bae.svg";
export { ForwardRef as ReactComponent };